


























import {Component, Mixins} from 'vue-property-decorator';
import {mapState, mapActions} from 'vuex';
import Login from '@/views/Login.vue';
import NavBar from '@/views/navbar/NavBar.vue';
import DescriptionsContainerMixin from '@/mixins/DescriptionsContainerMixin';

@Component({
    components: {
        Login,
        NavBar,
    },
    computed: {
        ...mapState(['authorized', 'loading']),
    },
    methods: {
        ...mapActions(['init']),
    },
})
export default class App extends Mixins(DescriptionsContainerMixin) {
    private errorSnackbar: boolean = false;
    private errorSnackbarMsg: string = '';

    public loading!: boolean;
    public authorized!: boolean;
    public init!: Function;

    async created() {
        this.init(this.$i18n);
    }
}
